import React from 'react';
import { Box, Paper, Typography, Stack } from '@mui/material';
import { Upload as UploadIcon } from '@mui/icons-material';
import { DoctorShiftCsvUploader } from '../components/DoctorShift/DoctorShiftCsvUploader';
import './ManagementList.css';

export const DoctorShiftUploadPage: React.FC = () => (
  <div className="management-page">
    <div className="management-heading">
      <div><h1>医師シフトCSVアップロード</h1><p>医師の勤務シフト情報をCSVファイルから一括登録できます</p></div>
    </div>

    <Paper className="management-panel" elevation={0} sx={{ p: { xs: 2, md: 2.5 } }}>
      <Typography variant="subtitle2" gutterBottom sx={{ fontWeight: 700 }}>CSVファイル形式について</Typography>
      <Stack spacing={1}>
        <Typography variant="body2" color="text.secondary">• タブ区切り形式のCSVファイルを使用してください</Typography>
        <Typography variant="body2" color="text.secondary">• 必須項目：医師名、勤務日付、診療開始時間、診療終了時間</Typography>
        <Typography variant="body2" color="text.secondary">• 日付形式：YYYY/MM/DD（例：2025/07/01）</Typography>
        <Typography variant="body2" color="text.secondary">• 時刻形式：H:MM または HH:MM（例：9:00、14:30）</Typography>
        <Typography variant="body2" color="text.secondary">• 同一医師の勤務時間が重複しないようご注意ください</Typography>
      </Stack>
    </Paper>

    <Paper className="management-panel" elevation={0} sx={{ p: { xs: 2, md: 2.5 } }}>
      <Stack direction="row" alignItems="center" spacing={1} mb={2}>
        <UploadIcon sx={{ color: 'secondary.main' }} />
        <Typography variant="h6" fontWeight={700}>ファイルアップロード</Typography>
      </Stack>
      <Box><DoctorShiftCsvUploader /></Box>
    </Paper>
  </div>
);
